var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5997 3.57686C15.9253 -1.89752 29.2404 7.68204 10.5997 20C-8.04103 7.68324 5.27412 -1.89752 10.5997 3.57686Z",
    fill: "#54362B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9771 6.63476L15.9135 6L15.2778 6.20151C14.1884 6.56148 13.0251 6.67195 11.8824 6.52393C10.6816 6.34671 9.45252 6.50419 8.34387 6.97733C7.75614 7.21534 7.24034 7.58938 6.84344 8.06539C6.44653 8.54141 6.18113 9.10429 6.07139 9.70277C5.9291 10.4759 6.00029 11.2709 6.27798 12.0101C6.45679 11.6262 6.66574 11.2558 6.90305 10.9018C7.44134 10.1485 8.18722 9.55072 9.05898 9.1738C9.89881 8.80913 10.8168 8.6366 11.7393 8.67002C10.8611 8.79773 10.0204 9.09798 9.27087 9.55164C8.90933 9.76768 8.57823 10.0267 8.2856 10.3224C8.00573 10.618 7.75897 10.9405 7.5493 11.2846C7.15547 12.004 6.87524 12.7747 6.71765 13.5718C6.54777 14.3715 6.45557 15.1843 6.44219 16H7.50162C7.55142 15.2684 7.65586 14.5412 7.81416 13.8237C8.5491 14.2011 9.37329 14.3936 10.2085 14.3829C10.9874 14.3824 11.7583 14.2333 12.4756 13.9446C16.5068 12.3073 15.9771 6.86146 15.9771 6.63476Z",
    fill: "#14B67D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.dcbbc39f359e192444a9a8faa2152ada.svg";
export { ForwardRef as ReactComponent };